var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOwnerIcon = function SvgOwnerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M5.74 13h8.52a.7.7 0 0 0 .523-.243.88.88 0 0 0 .217-.587V7.69a.44.44 0 0 0-.058-.223.4.4 0 0 0-.157-.15.34.34 0 0 0-.208-.033.36.36 0 0 0-.192.099l-2.222 2.166a.2.2 0 0 1-.133.05.19.19 0 0 1-.126-.075L10.096 7.14a.4.4 0 0 0-.127-.104.34.34 0 0 0-.308 0 .4.4 0 0 0-.128.104L7.726 9.514a.2.2 0 0 1-.06.049.2.2 0 0 1-.073.018.15.15 0 0 1-.077-.01.2.2 0 0 1-.064-.048L5.63 7.49a.34.34 0 0 0-.19-.11.3.3 0 0 0-.21.035.37.37 0 0 0-.168.15.44.44 0 0 0-.062.232v4.39a.88.88 0 0 0 .222.576.7.7 0 0 0 .519.237z"
  })));
};
export { SvgOwnerIcon as ReactComponent };